import React from 'react';
import Loading from './Loading';
function ContentWithTranslation(props) {
    var contentKey = props.contentKey, defaultLocale = props.defaultLocale, locale = props.locale, loading = props.loading, translations = props.translations;
    var getTranslation = function () {
        if (locale && translations[locale] && translations[locale][contentKey]) {
            return translations[locale][contentKey];
        }
        if (translations[defaultLocale] && translations[defaultLocale][contentKey]) {
            return translations[defaultLocale][contentKey];
        }
        return;
    };
    if (loading) {
        return React.createElement(Loading, null);
    }
    var translatedText = getTranslation();
    if (!translatedText) {
        return;
    }
    return React.createElement("div", { className: "space-pre-line" }, translatedText);
}
export default ContentWithTranslation;
